<template>
  <div>
    <div v-if="show" id="survey-form">
        <label for="title"><b>Title</b></label>
        <input v-model="newTitle" class="input" placeholder="Title" name="title" required />
        <label for="audio"><b>Audio</b></label>
        <input @change="onAudioSelected" type="file" name="audio" accept="audio/*" required>
        <label for="pdf"><b>Pdf</b></label>
        <input @change="onPdfSelected" type="file" name="pdf" accept=".pdf" required>
        <button @click="createChatRoom(), $emit('update:show', 0)" class="button">Publish Article</button>
    </div>
  </div>
</template>

<script>
import { db, storage } from '../firebase';
import swal from 'sweetalert';
import { PDFDocument } from 'pdf-lib';

export default {
  data() {
    return { 
        chats: [],
        newTitle: "",
        chatId: null,
        pub: ''
    }
  },
  firestore() {
    return { 
        chats: db.collection('chats').where('owner', '==', this.uid),
        pub: db.doc(`users/${this.uid}`) 
    }
  },
  methods: {
      async createChatRoom() {
        this.$emit('ublished', 0);
          swal("Almost done!", "You will receive a notificatoin when your article has been uploaded, DO NOT REFRESH THIS PAGE before that!", "warning");

          let pdfURL = null;
          let mainAudioURL = null;
          
          const pdfStorageRef = storage
              .ref('pdf')
              .child(this.uid)
              .child(`${this.newTitle}`)
              .child(`${this.pdfFile.name}`);
            await pdfStorageRef.put(this.pdfFile);
            pdfURL = await pdfStorageRef.getDownloadURL();


        
            const audioStorageRef = storage
              .ref('audio')
              .child(this.uid)
              .child(`${this.newTitle}`)
              .child(`${this.audioFile.name}`);
            await audioStorageRef.put(this.audioFile);
            mainAudioURL = await audioStorageRef.getDownloadURL();

            this.chatId = this.newTitle + '-' + this.uid;

          const newChat = await db.collection('chats').doc(`${this.chatId}`).set({
              createdAt: Date.now(),
              owner: this.uid,
              members: [this.uid],
              title: this.newTitle,
              pdfURL,
              mainAudioURL,
              publisher: this.pub.userName
          })

            const url = pdfURL;
            const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());
            console.log(newChat);
            const pdfDoc = await PDFDocument.load(existingPdfBytes);
            const totalPages = pdfDoc.getPageCount();
            for(let i = 1; i <= totalPages; i++){
              db.doc(`chats/${this.chatId}/metaData/expressions/totals/${i}`).set({
                bliss: 0, 
                fedUp: 0,
                oooh: 0,
                dead: 0,
                cry: 0,
                page: i
              });
            }
            const coverPdfDoc = await PDFDocument.create();
            const [pdfPage] = await coverPdfDoc.copyPages(pdfDoc, [0])
            coverPdfDoc.addPage(pdfPage)
            const pdfBytes = await coverPdfDoc.save()

            const coverPdfStorageRef = storage
              .ref('pdf')
              .child(this.uid)
              .child(`${this.newTitle}`)
              .child('cover'+'-'+`${this.pdfFile.name}`);
            await coverPdfStorageRef.put(pdfBytes);
            const coverPdfURL = await coverPdfStorageRef.getDownloadURL();

            const newChatCover = await db.collection('chats').doc(`${this.chatId}`).update({
              coverPdfURL
          })

            console.log(totalPages);
            console.log(coverPdfStorageRef);
            console.log(newChatCover);
            swal("Success!", "Your article has been uploaded!", "success");
      },
      onAudioSelected (event){
          this.audioFile = event.target.files[0];
      },
      onPdfSelected (event){
          this.pdfFile = event.target.files[0];
      }
      // async onUpload(){
      //       const storageRef = storage
      //         .ref('pdf')
      //         .child(`${this.selectedFile.name}`);
      //       await storageRef.put(this.selectedFile)
      // },

      
  },
  props: ['uid', 'show']

};


// const fd = new FormData()
        // fd.append('pdf', this.selectedFile, this.selectedFile.name)
        // axios.post('https://us-central1-feedback-60109.cloudfunctions.net/uploadFile', this.selectedFile, fd)

        // let pdfURL = null;
        // const fd = new FormData();
        // fd.append('PDF', this.selectedFile, this.selectedFile.name)
        // const storageRef = storage
        //     .ref('pdf')
        //     .child(this.pdf);

        //     await storageRef.put(fd);

        //   pdfURL = await storageRef.getDownloadURL();
        //   console.log(pdfURL);
</script>

<style>

  #survey-form {
    background-color: #fefefe;
    margin: 5% auto 15% auto; /* 5% from the top, 15% from the bottom and centered */
    border: 1px solid #888;
    width: 80%; /* Could be more or less, depending on screen size */
  }
  
  /* Full-width input fields */
  input[type=text], input[type=file] {
    width: 100%;
    padding: 12px 20px;
    margin: 8px 0;
    display: inline-block;
    border: 1px solid #ccc;
    box-sizing: border-box;
  }
  
</style>
